import { render, staticRenderFns } from "./CrudTableShowDataAs.vue?vue&type=template&id=0a08845a&scoped=true"
import script from "./CrudTableShowDataAs.vue?vue&type=script&lang=js"
export * from "./CrudTableShowDataAs.vue?vue&type=script&lang=js"
import style0 from "./CrudTableShowDataAs.vue?vue&type=style&index=0&id=0a08845a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a08845a",
  null
  
)

export default component.exports